export default "__VITE_ASSET__BvEEyTXw__"